import type { GenericError, RequestStatus } from '@skynet/data-ws-core';

export enum LoanAmountsCommands {
  LoanAmounts = 'LoanAmounts',
  AddLoanAmount = 'AddLoanAmount',
  UpdateLoanAmount = 'UpdateLoanAmount',
  DeleteLoanAmount = 'DeleteLoanAmount',
}

export interface LoanAmountItem {
  id: number;
  type: number;
  currency: string;
  amount: number;
  price: number;
  created_at: string;
  created_by?: string;
  description?: string;
  /**
   * Date the transaction is agreed/executed. For OTC trenches this is the token
   * unlock date; for regular loan amounts it is the transaction date. ISO date string.
   */
  transactionDate?: string;
}

export interface JsonLoanAmountsSuccess {
  command: string;
  amounts: LoanAmountItem[];
}

export interface LoanAmountsState {
  amounts: LoanAmountItem[];
  status: RequestStatus;
  updateStatus: RequestStatus;
  deleteStatus: RequestStatus;
  /** Error for the add flow — kept separate per operation so one command's failure can't surface under another's selector. */
  error: GenericError | null;
  updateError: GenericError | null;
  deleteError: GenericError | null;
}

export interface AmountsByTypeRow {
  currency: string;
  base: number;
  quote: number;
}

export interface AmountsTotalsByType {
  base: number;
  quote: number;
}
